import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { supabase } from '@/lib/supabase';

type Props = {
  projectId: string;
};

export type ProjectMemberWithProfile = {
  project_id: number;
  org_member_id: string;
  created_at: string | null;
  org_member: OrgMemberWithProfile;
};

export const getProjectMembers = async ({ projectId }: Props) => {
  const { data, error } = await supabase
    .from('project_members')
    .select(
      `
      *,
      org_member:org_members!inner(
        *,
        profile:profiles!inner(*)
      )
    `,
    )
    .eq('project_id', Number(projectId));

  if (error) {
    throw error;
  }
  return data;
};
